import { Box, Flex, Option, RadioButton, Select, Tooltip } from '@modusign/design-system';
import moment from 'moment';
import { Controller, useFormContext } from 'react-hook-form-v7';

import { BasicInformationFormState } from '@app/features/externalDocument/components/BasicInformationEditor';

export default function RenewalInput() {
  const { watch, register } = useFormContext<BasicInformationFormState>();
  const periodInYears = watch('renewal.periodInYears');
  const dateOfCompletion: string | null = watch('dateOfCompletion');

  const renewalChecked = watch('renewalRadio') === '1';

  const renewalRadioFieldProps = register('renewalRadio');

  return (
    <Flex flexDirection="column" py={renewalChecked ? 2 : undefined}>
      <Flex>
        <Tooltip
          content="선택하려면 계약 체결일을 입력해 주세요."
          isOpen={dateOfCompletion ? false : undefined}
          placement="top"
        >
          <Flex as="label" fontWeight="medium" gap={3} sx={{ alignItems: 'center' }}>
            <RadioButton
              disabled={!dateOfCompletion}
              {...renewalRadioFieldProps}
              value={1}
              onClick={(event) => renewalRadioFieldProps.onChange(event)}
            />
            <span>갱신함</span>
          </Flex>
        </Tooltip>
        <Flex as="label" fontWeight="medium" gap={3} sx={{ alignItems: 'center', ml: 4 }}>
          <RadioButton
            defaultChecked
            {...renewalRadioFieldProps}
            value={0}
            onClick={(event) => renewalRadioFieldProps.onChange(event)}
          />
          <span>갱신 안 함</span>
        </Flex>
      </Flex>
      {dateOfCompletion && renewalChecked && (
        <>
          <Box mt={4}>
            계약 종료일 기준{' '}
            <Box display="inline-block" mx={3} width="80px">
              <Controller
                defaultValue={-1}
                name="renewal.noticeBeforeExpirationInDays"
                render={({ field: { value, onChange } }) => (
                  <Select value={value} onChange={(event) => onChange(Number(event.target.value))}>
                    <Option value={-1}>없음</Option>
                    <Option value={30}>30일</Option>
                    <Option value={60}>60일</Option>
                    <Option value={90}>90일</Option>
                    <Option value={120}>120일</Option>
                  </Select>
                )}
              />
            </Box>
            일 전까지 상대측에게 통지가 필요합니다.
          </Box>
          <Box mt="2px">
            <Box display="inline-block" mr={3} width="80px">
              <Controller
                defaultValue={1}
                name="renewal.periodInYears"
                render={({ field: { value, onChange } }) => (
                  <Select value={value} onChange={(event) => onChange(Number(event.target.value))}>
                    {Array(10)
                      .fill(1)
                      .map((_, i) => (
                        <Option
                          // eslint-disable-next-line react/no-array-index-key
                          key={i}
                          value={i + 1}
                        >
                          {`${i + 1}년`}
                        </Option>
                      ))}
                  </Select>
                )}
              />
            </Box>
            마다 계약을 갱신합니다. 다음 계약일은{' '}
            {moment(dateOfCompletion).add(periodInYears, 'years').format('YYYY.MM.DD')}
            입니다.
          </Box>
        </>
      )}
    </Flex>
  );
}
